import { useQuery } from "@tanstack/react-query";

import { MasterInstance } from "@/instance/axios";
import {
  AuthorizationsGet200Response,
  AuthorizationsGet200ResponseRowsInner,
} from "@sizlcorp/sizl-api-document/dist/models";

export type AuthorityOption = {
  value: string;
  label: string;
};

export const useAuthoritiesMultiAutoComplete = (
  focus = false,
  keyword = "",
  options?: {
    onSuccess: (data: AuthorityOption[]) => void;
  }
) => {
  return useQuery(
    ["authorities-get-multi-autocomplete-keyword", keyword],
    () =>
      MasterInstance.authorizationsFindPost({
        search: keyword,
        searchFields: ["name"],
      }).then((res) => res.data),
    {
      enabled: focus,
      select: (data: AuthorizationsGet200ResponseRowsInner[]): AuthorityOption[] =>
        data.map((Authority) => {
          return {
            value: String(Authority.code),
            label: String(Authority.name),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    }
  );
};

const getAuthorityByCode = (code: string | null) =>
  MasterInstance.authorizationsGet({
    ...(code && { search: code }),
    searchFields: ["code"],
  }).then((res) => res.data);

export const useAuthoritiesMultiCode = (
  enabled: boolean = false,
  code: string | null,
  options?: {
    onSuccess: (data?: AuthorityOption[]) => void;
  }
) => {
  return useQuery(["authorities-multi-get-code", code], () => getAuthorityByCode(code), {
    enabled,
    select: (data: AuthorizationsGet200Response) =>
      data?.rows?.map((Authority) => {
        return {
          value: Authority.code as string,
          label: Authority.name as string,
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
